import React from 'react'
import { connect } from 'react-redux'
import Zestawienie from '../../components/Zestawienie/Zestawienie'
import ZestawienieHeader from '../../components/Zestawienie/ZestawienieHeader'
import ZestawienieName from '../../components/Zestawienie/ZestawienieName'
import { formulyRachunekPrzeplywowDM } from '../../lib/formulas'
import zaokragl from '../../lib/mathUtils'
import { czyKwotyWTysiacach } from '../../lib/structureChecker'
import * as actions from '../../store/actions'
import RachunekPrzeplywowStyle from '../../styles/RachunekPrzeplywowStyle'
import ImportCSVInfo from '../../components/Zestawienie/ImportCSVInfo'
import InfoPanel from '../../components/InfoPanel'

export class RachunekPrzeplywowDomMaklerski extends React.Component {
  isValueInThirdColumn = () => {
    return this.props.section.Dane.Pozycje.some(i => i.KwotaB1 !== 0)
  }

  state = { isThirdColumn: this.isValueInThirdColumn(), czyszczenie: false }

  setIsThirdColumn = v => {
    this.setState({ isThirdColumn: v })
  }

  getValue = (index, name) => {
    return this.props.section.Dane.Pozycje[index][name]
  }

  sumValues = (value, changedIndex, name, parts) => {
    let partsSum = 0
    parts.forEach(x => {
      if (x < 0) {
        let i = Math.abs(x)
        partsSum = zaokragl(
          partsSum -
            (i === changedIndex ? parseFloat(value) : this.getValue(i, name)),
        )
      } else
        partsSum = zaokragl(
          partsSum +
            (x === changedIndex ? parseFloat(value) : this.getValue(x, name)),
        )
    })
    return partsSum
  }

  aktualizujSumy = (value, index, name) => {
    if (this.state.czyszczenie) return
    if (!value) value = 0
    this.props.onSetSectionDataArray(value, index, name)
    formulyRachunekPrzeplywowDM.forEach(x => {
      let suma = this.sumValues(value, index, name, x.polaSkladowe)
      this.props.onSetSectionDataArray(suma, x.poleSumy, name)
    })
  }

  czyszczenie = async () => {
    this.setState({ czyszczenie: true })
    this.props.onClearTable('Pozycje')
    await this.setState({ czyszczenie: false })
  }

  render() {
    const { section, czyKwotyWTysiacach, id, onImportCSV } = this.props
    return (
      <>
        <InfoPanel rolledContent={ImportCSVInfo} />
        <RachunekPrzeplywowStyle>
          <ZestawienieName
            name="RACHUNEK PRZEPŁYWÓW PIENIĘŻNYCH DOMU MAKLERSKIEGO"
            onImport={file => onImportCSV(id, section, file)}
            onClear={this.czyszczenie}
          />
          <div className="container">
            <ZestawienieHeader
              isThirdColumn={this.state.isThirdColumn}
              onCheck={e => this.setIsThirdColumn(e.target.checked)}
            />
            <div className="list">
              <Zestawienie
                dane={section.Dane.Pozycje}
                onSetSectionDataArray={this.aktualizujSumy}
                czyKwotyWTysiacach={czyKwotyWTysiacach}
                isThirdColumn={this.state.isThirdColumn}
              />
            </div>
          </div>
        </RachunekPrzeplywowStyle>
      </>
    )
  }
}
const mapStateToProps = state => {
  return {
    czyKwotyWTysiacach: czyKwotyWTysiacach(state.sprawozdanie.header),
    id: state.sprawozdanie.header.Id,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSetSectionDataArray: (v, i, n) => {
      dispatch(actions.setSectionDataArray(v, i, 0, n))
    },
    onImportCSV: (id, section, file) => {
      dispatch(actions.importCSV(id, section, file))
    },
    onClearTable: array => dispatch(actions.clearTable(array)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RachunekPrzeplywowDomMaklerski)
